import { defineEphemeralSlice } from "../runtime/defineEphemeralSlice";
import type { ExchangeRateSession } from "../types";

/** Default exchange rate session before the first API fetch. */
export const EXCHANGE_RATE_SESSION_DEFAULT: ExchangeRateSession = { "chfToEurRate": null };

/** CHF→EUR multiplier from the pricing API for the current session. */
export const exchangeRateSessionSlice = defineEphemeralSlice<ExchangeRateSession>( {
    "key":     "exchangeRateSession",
    "default": () => EXCHANGE_RATE_SESSION_DEFAULT,
} );
